<template>
  <Header></Header>
  <el-card class="box-card">
    <template #header>
      <div class="card-header">
        <span>修改密码</span>
      </div>
    </template>
    <el-form ref="mFormRef" :model="mForm" :rules="mRules" label-width="100px">
      <el-form-item label="用户名">
        <el-input
          v-model="mForm.userName"
          placeholder="请输入用户名"
          disabled
        ></el-input>
      </el-form-item>
      <el-form-item label="原密码" prop="oldPassword">
        <el-input
          v-model="mForm.oldPassword"
          :type="showPassword ? 'text' : 'password'"
          placeholder="原密码"
        />
        <div class="eye-p">
          <img
            v-show="showPassword"
            src="@/assets/image/eye.png"
            @click="showPassword = false"
          />
          <img
            v-show="!showPassword"
            src="@/assets/image/closeEye.png"
            @click="showPassword = true"
          />
        </div>
      </el-form-item>
      <el-form-item label="新密码" prop="newPassword">
        <el-input
          v-model="mForm.newPassword"
          :type="showPassword2 ? 'text' : 'password'"
          placeholder="8-32位，含大小写字母、数字或特殊符号的其中两项"
        />
        <div class="eye-p">
          <img
            v-show="showPassword2"
            src="@/assets/image/eye.png"
            @click="showPassword2 = false"
          />
          <img
            v-show="!showPassword2"
            src="@/assets/image/closeEye.png"
            @click="showPassword2 = true"
          />
        </div>
      </el-form-item>
      <el-form-item label="确认密码" prop="rePassword">
        <el-input
          v-model="mForm.rePassword"
          :type="showPassword3 ? 'text' : 'password'"
          placeholder="需和上次输入一致"
        />
        <div class="eye-p">
          <img
            v-show="showPassword3"
            src="@/assets/image/eye.png"
            @click="showPassword3 = false"
          />
          <img
            v-show="!showPassword3"
            src="@/assets/image/closeEye.png"
            @click="showPassword3 = true"
          />
        </div>
      </el-form-item>
      <el-form-item label="安全问题" prop="rePassword">
        <p>
          请设置下方安全问题，方便您在忘记密码时，通过回答安全问题找回<span
            v-show="userInfo.isDefaultPass != 1 || !roleNeedqa"
          >
            （非必填）</span
          >
        </p>
      </el-form-item>
      <el-form-item label="问题">
        <el-select v-model="mForm.question" placeholder="请选择问题">
          <el-option
            label="请输入您的出生年月日（如：1900101）"
            value="请输入您的出生年月日（如：1900101）"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="回答">
        <el-input v-model="mForm.answer" placeholder="请输入答案"></el-input>
      </el-form-item>
      <el-form-item label="图形验证码" prop="imageCode">
        <el-row :gutter="20">
          <el-col :md="18" :lg="18" :sm="15" :xs="12">
            <el-input
              v-model="mForm.imageCode"
              placeholder="请填写计算的结果"
            />
          </el-col>
          <el-col :span="6" :xs="10">
            <img
              class="code-img"
              alt="图形验证码"
              title="点击刷新"
              @click="refreshCode()"
              :src="codeImg"
            />
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item class="mobileAgreement">
        <el-checkbox
          v-model="customCheck"
          type="checkbox"
          class="custom-control-input"
          id="customCheck"
          style="margin-right: 10px"
        />
        <label class="custom-control-label" for="customCheck"
          >我已阅读并同意<router-link target="_blank" to="/agreement"
            >《外研教学评用户协议》</router-link
          >
          <router-link target="_blank" to="/privacy"
            >《外研教学评隐私政策》</router-link
          ></label
        >
      </el-form-item>
      <el-form-item>
        <el-button class="largeBtn" type="primary" @click="modifyPassword()"
          >确认修改</el-button
        >
      </el-form-item>
    </el-form>
    <div class="clearFloat">
      <div class="floatR">
        <router-link to="/login">登录系统</router-link>
      </div>
    </div>
  </el-card>
</template>

<script>
import Header from "@/components/Header.vue";
import { _createUUID } from "@/utils/utils.js";
import {
  validatePassword,
  validateNull,
  validatePassNull,
} from "@/utils/validate.js";
import { localStore, moduleInfos } from "@/utils/utils.js";
import { toRefs, reactive, getCurrentInstance, onMounted } from "vue";
import {
  toModifyPassword,
  AutoLogin,
  updateUserSecurityQuestions,
  getUserSecurityQuestions,
} from "@/api/api.js";
import { ElMessage } from "element-plus";
import { useRouter } from "vue-router";
export default {
  components: { Header },
  setup() {
    const { proxy } = getCurrentInstance(); // 使用proxy代替ctx，因为ctx只在开发环境有效
    const router = useRouter();
    const state = reactive({
      mForm: {
        userName: router.currentRoute.value.query.userName,
        oldPassword: "",
        newPassword: "",
        rePassword: "",
        imageCode: "",
        answer: "",
        question: "",
        id: "",
      },
      mFormRef: null,
      customCheck: false,
      uuId: "",
      codeImg: "",
      showPassword: false,
      showPassword2: false,
      showPassword3: false,
    });
    onMounted(() => {
      //获取安全问题
      getUserSecurityQuestions({
        userId: userInfo.userId,
      }).then((r) => {
        if (r.status == 0 && r.data.list && r.data.list[0]) {
          state.mForm.id = r.data.list[0].id;
        }
      });
      refreshCode();
    });
    const clearRedirect = () => {
      window.sessionStorage.removeItem(state.keyRedirect);
    };
    const getRedirect = () => {
      return window.sessionStorage.getItem(state.keyRedirect);
    };
    //获取图片验证码
    const refreshCode = () => {
      // 生成32位UUID
      state.uuId = _createUUID();
      //设置图片验证码
      state.codeImg =
        process.env.VUE_APP_BASE_PATH + "/auth/code?clientId=" + state.uuId;
    };
    const validateRePassword = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("密码不能为空"));
      } else {
        if (value !== state.mForm.newPassword) {
          callback(new Error("两次密码输入不一致！"));
        }
        callback();
      }
    };
    const mRules = {
      oldPassword: [{ validator: validatePassNull, trigger: "blur" }],
      imageCode: [{ validator: validateNull, trigger: "blur" }],
      newPassword: [{ validator: validatePassword, trigger: "blur" }],
      rePassword: [{ validator: validateRePassword, trigger: "blur" }],
    };
    const dealLogin = (data, yjChannelId) => {
      let addData = data["additionalInformation"];
      localStore("userId", addData["userId"]);
      localStore("userName", addData["userName"]);
      localStore("userRole", addData["userRole"]);
      localStore("userOrganizes", JSON.stringify(addData["userOrganizes"]));
      localStore("fullName", addData["fullName"]);
      localStore("portrait", addData["portrait"]);
      localStore("registerType", addData["registerType"]);
      localStore("userAppRoles", JSON.stringify(addData["userAppRoles"]));
      localStore("channelId", yjChannelId);
      localStore("mobile", addData["mobile"]);
      // 带有悦测评重定向的地址
      if (router.currentRoute.value.query.redirect_url) {
        window.location.href = decodeURIComponent(
          router.currentRoute.value.query.redirect_url
        );
        return;
      }
      // 带有悦教大讲堂重定向的地址
      if (yjChannelId) {
        if (yjChannelId == "fjyd") {
          window.location.href = "yuejiao/route.html?channel=fjyd";
          return;
        }
      }
      if (addData["defaultPass"] || addData["changePass"]) {
        //需要修改密码的情况
        ElMessage({
          message: "请修改密码,即将跳转修改密码页.......",
          type: "warning",
        });
        setTimeout(
          () =>
            router.push({
              path: "/setUserInfo",
              query: {
                changePwd: true,
              },
            }),
          3000
        );
      } else {
        //不需要修改密码的情况
        var haveAuthArr = [];
        var log_id = localStore("loginId");
        let info = JSON.parse(localStore("userAppRoles"));
        if (log_id && (info.length != 0 || addData["userRole"] != 4)) {
          // 有路径跳转地址时
          var redirectUrl = getRedirect();
          if (redirectUrl) {
            clearRedirect();
            window.location.href = redirectUrl;
          } else if (state.hrefCode && state.hrefUrl) {
            info.forEach(function (item) {
              haveAuthArr.push(item.appCode);
            });
            if (haveAuthArr.indexOf(state.hrefCode) !== -1) {
              window.location.href = state.hrefUrl;
            } else {
              // 无权限，跳转至新页面
              router.push({
                path: "/noAuth",
                query: {
                  appCode: state.hrefCode,
                },
              });
            }
            if (window.opener != null) {
              var isIndex = window.opener.location.pathname.substring(
                window.opener.location.pathname.lastIndexOf("/")
              );
              if (isIndex == "/login") {
                //如果父页面是login或者为空则不刷新页面
              } else {
                window.opener.location.reload(true);
              }
            }
          } else {
            router.push("/myApp");
          }
        } else {
          ElMessage({
            message: "您没有任何子系统的权限",
            type: "warning",
          });
          router.push("/myApp");
        }
      }
    };
    let userInfo =
      window.localStorage.getItem("fltrp-home-autoUser") &&
      JSON.parse(window.localStorage.getItem("fltrp-home-autoUser"));
    let roleNeedqa = userInfo.userAppRoles.some((item) => {
      if (
        item.appCode == "primary" ||
        item.appCode == "junior" ||
        item.appCode == "jizhen"
      ) {
        return true;
      }
    });
    const modifyPassword = () => {
      //验证安全问题填写
      if (userInfo && userInfo.isDefaultPass == 1 && roleNeedqa) {
        if (!state.mForm.answer || !state.mForm.question) {
          ElMessage({
            message: "请设置安全问题",
            type: "warning",
          });
          return 0;
        }
      }
      state.mFormRef.validate((valide) => {
        console.log(valide);
        if (valide) {
          if (state.customCheck) {
            if (state.mForm.answer && state.mForm.question) {
              updateUserSecurityQuestions({
                userId: userInfo.userId,
                answer: state.mForm.answer,
                question: state.mForm.question,
                id: state.mForm.id,
              }).then((r) => {
                if (r.status != 0) {
                  ElMessage({
                    message: r["msg"],
                    type: "warning",
                  });
                  return 0;
                }
                toModifyPassword({
                  userName: proxy.$encryption(state.mForm.userName),
                  oldPassword: proxy.$encryption(state.mForm.oldPassword),
                  newPassword: proxy.$encryption(state.mForm.newPassword),
                  clientId: state.uuId,
                  imageCode: state.mForm.imageCode,
                }).then((response) => {
                  if (response["status"] == 0) {
                    let role =
                      window.localStorage.getItem("fltrp-home-autoUser") &&
                      JSON.parse(
                        window.localStorage.getItem("fltrp-home-autoUser")
                      ).userRole;
                    if (role != 1) {
                      ElMessage({
                        message: "修改密码成功。",
                        type: "success",
                      });
                      AutoLogin().then((response) => {
                        var rolesArr =
                          response["data"]["additionalInformation"][
                            "userAppRoles"
                          ];
                        for (var i = 0; i < rolesArr.length; i++) {
                          var moduleInfo = moduleInfos[rolesArr[i].appCode];
                          if (moduleInfo) {
                            rolesArr[i].url = moduleInfo["url"];
                            rolesArr[i].img = "image/" + moduleInfo["logo"];
                          }
                        }
                        localStore("token", response["data"]["accessToken"]);
                        localStore("tokenType", response["data"]["tokenType"]);
                        localStore(
                          "refreshToken",
                          response["data"]["refreshToken"]
                        );
                        localStore(
                          "isExpiredPass",
                          response["data"]["additionalInformation"][
                            "isExpiredPass"
                          ]
                        );
                        localStore(
                          "loginId",
                          response["data"]["additionalInformation"].userName
                        );
                        dealLogin(response["data"], state.yjChannelId);
                      });
                    } else {
                      ElMessage({
                        message: "修改密码成功，即将返回登录页",
                        type: "success",
                      });
                      setTimeout(() => router.push("/login"), 3000);
                    }
                  } else {
                    refreshCode();
                    ElMessage({
                      message: response["msg"],
                      type: "warning",
                    });
                  }
                });
              });
            } else {
              toModifyPassword({
                userName: proxy.$encryption(state.mForm.userName),
                oldPassword: proxy.$encryption(state.mForm.oldPassword),
                newPassword: proxy.$encryption(state.mForm.newPassword),
                clientId: state.uuId,
                imageCode: state.mForm.imageCode,
              }).then((response) => {
                if (response["status"] == 0) {
                  let role =
                    window.localStorage.getItem("fltrp-home-autoUser") &&
                    JSON.parse(
                      window.localStorage.getItem("fltrp-home-autoUser")
                    ).userRole;
                  if (role != 1) {
                    ElMessage({
                      message: "修改密码成功。",
                      type: "success",
                    });
                    AutoLogin().then((response) => {
                      var rolesArr =
                        response["data"]["additionalInformation"][
                          "userAppRoles"
                        ];
                      for (var i = 0; i < rolesArr.length; i++) {
                        var moduleInfo = moduleInfos[rolesArr[i].appCode];
                        if (moduleInfo) {
                          rolesArr[i].url = moduleInfo["url"];
                          rolesArr[i].img = "image/" + moduleInfo["logo"];
                        }
                      }
                      localStore("token", response["data"]["accessToken"]);
                      localStore("tokenType", response["data"]["tokenType"]);
                      localStore(
                        "refreshToken",
                        response["data"]["refreshToken"]
                      );
                      localStore(
                        "isExpiredPass",
                        response["data"]["additionalInformation"][
                          "isExpiredPass"
                        ]
                      );
                      localStore(
                        "loginId",
                        response["data"]["additionalInformation"].userName
                      );
                      dealLogin(response["data"], state.yjChannelId);
                    });
                  } else {
                    ElMessage({
                      message: "修改密码成功，即将返回登录页",
                      type: "success",
                    });
                    setTimeout(() => router.push("/login"), 3000);
                  }
                } else {
                  refreshCode();
                  ElMessage({
                    message: response["msg"],
                    type: "warning",
                  });
                }
              });
            }
          } else {
            ElMessage({
              message: "请阅读并选中协议～",
              type: "warning",
            });
          }
        }
      });
    };
    return {
      ...toRefs(state),
      modifyPassword,
      refreshCode,
      mRules,
      userInfo,
      roleNeedqa,
    };
  },
};
</script>

<style lang="scss" scoped></style>
